module.exports = __webpack_public_path__ + "images/stickers/pete-broken.e0c1fadd8cdf3173a4cf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-broken.png
// module id = 02Og
// module chunks = 2